// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"d8fac957","787":"cd87fa55"}[chunkId] + ".chunk.js";
};